import React, { useState, useEffect } from 'react';
import './goodsStore.css';
import { useDispatch, useSelector } from "react-redux";
import StoreForm from "../StoreForm/StoreForm";
import { setRestGoodsFormAction, storeFormAction } from "../../redux/rootReducer";
import growl from "../../lib/growl/growl";
import FilterSelect from "../FilterSelect/FilterSelect";
import { dropdownAction } from "../../redux/rootReducer";
import GoodsRestForm from "../GoodsRestForm/GoodsRestForm";

const GoodsStore = () => {
    const dispatch = useDispatch();
    const goods = useSelector(state => state.goods);
    const groups = useSelector(state => state.groups);
    const storeForm = useSelector(state => state.storeForm);
    const dropdown = useSelector(state => state.dropdown);
    const rest_goods_form = useSelector(state => state.rest_goods_form);

    const [amount, setAmount] = useState({ goods_id: '', amount: 1 });

    const [goodsGroup, setGoodsGroup] = useState([]);
    const [visibleGoods, setVisibleGoods] = useState([]);

    useEffect(() => {
        if (!groups.length) return;

        setGoodsGroup(groups.map(elem => ({ ...elem, active: false })));
    }, [groups]);


    useEffect(() => {
        // Отображаемые группы товаров
        let visibleGroups = goodsGroup.filter(elem => elem.active).map(elem => elem.id);
        // Отображаемые товары
        if (!visibleGroups.length) {
            setVisibleGoods([...goods]);
        }
        else {
            setVisibleGoods(goods.filter(elem => visibleGroups.includes(elem.group.id)));
        }
    }, [goodsGroup, goods]);

    return (
        <div className="page__content">
            { storeForm.open && <StoreForm/> }
            { rest_goods_form.open && <GoodsRestForm/> }
            <div className="table__header">
                <div className="table__caption">Продажа товаров</div>
                <div className="store__filter">
                    <FilterSelect
                        placeholder={ 'Группы товаров' }
                        options={ goodsGroup }
                        handler={ id => setGoodsGroup(
                            goodsGroup.map(elem => {
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            })
                        ) }
                        open={ dropdown === 'goods_type' }
                        openHandler={ () => dispatch(dropdownAction('goods_type')) }
                        clear={ () => setGoodsGroup(
                            goodsGroup.map(elem => ({ ...elem, active: false }))
                        ) }
                    />
                </div>
            </div>
            <div className="table store__table">
                <div className="table__row table__row--header store__row">
                    <div className="table__cell table__cell--left">Название</div>
                    <div className="table__cell">Стоимость</div>
                    <div className="table__cell">Количество</div>
                    <div className="table__cell">Остаток</div>
                    <div className="table__cell"/>
                </div>
                {
                    visibleGoods.map(elem => (
                        <div className="table__row store__row" key={ elem.id }>
                            <div className="table__cell table__cell--left">{ elem.name }</div>
                            <div className="table__cell">{ elem.cost }</div>
                            <input type="text" className="table__cell input--cell"
                                value={ amount.goods_id === elem.id ? amount.amount : 1 }
                                onInput={ event => setAmount({ goods_id: elem.id, amount: event.target.value }) }
                            />
                            <div className="table__cell table__cell--hover"
                                onClick={ () => dispatch(setRestGoodsFormAction({
                                    open: true,
                                    goods_id: elem.id,
                                    rest: elem.rest
                                })) }
                            >{ elem.rest }</div>
                            <div className="table__cell">
                                <div className="store__purchase"
                                    onClick={ () => {
                                        // Подсчитываем стоимость исходя из количества
                                        let costRatio = parseInt(amount.goods_id === elem.id ? amount.amount : 1);

                                        if (isNaN(costRatio)) {
                                            growl({ type: 'error', message: 'Пожалуйста, укажите корректое количество' });
                                            return;
                                        }

                                        dispatch(storeFormAction({
                                            open: true,
                                            user: { id: '', name: '' },
                                            users: [],
                                            goods_id: elem.id,
                                            goods_name: elem.name,
                                            payment: [{ index: 1, cost: (elem.cost * costRatio).toFixed(2), payment_method: { id: '', name: '' }}],
                                            discount: { id: '', name: 'Нет скидки', percent: '0' },
                                            total_sum: (elem.cost * costRatio).toFixed(2),
                                            amount: costRatio
                                        }));
                                    } }
                                >Оформить</div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default GoodsStore;